// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"6":"014ad0d1","60":"3aeaa7b0","205":"35757e41","283":"7dbcadb7","715":"81bc51e9","988":"35a2aa58"}[chunkId] + ".chunk.js";
};